import axios from "axios";
import { useEffect, useState } from "react";

import { useLogout } from "modules/Login/hooks/useLogout";

import type { ReactNode } from "react";

export const Axios401Interceptor = ({ children }: { children: ReactNode }) => {
  const [isReady, setIsReady] = useState(false);
  const logout = useLogout();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) logout();

        throw error;
      }
    );

    setIsReady(true);
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  return isReady && children;
};
